import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/auftragssuche`;
const headers = () => ({ headers: { Authorization: "Bearer " + localStorage.getItem("token") } });
const leadUrl = (key, suffix = "") => `${base}/leads/${encodeURIComponent(key)}${suffix}`;

export const getMeta = () => axios.get(`${base}/meta`, headers());
export const getProfile = () => axios.get(`${base}/profile`, headers());
export const saveProfile = body => axios.put(`${base}/profile`, body, headers());
export const getStatus = () => axios.get(`${base}/status`, headers());
export const startSync = () => axios.post(`${base}/sync`, {}, headers());
export const listLeads = filters => axios.post(`${base}/leads`, filters, headers());
export const getLead = key => axios.get(leadUrl(key), headers());
export const setLeadStatus = (key, body) => axios.put(leadUrl(key, "/status"), body, headers());
export const prepareOffer = key => axios.get(leadUrl(key, "/prepare"), headers());
export const calculateOffer = (key, body) =>
  axios.post(leadUrl(key, "/calculate"), body, headers());
export const createOffer = (key, body) => axios.post(leadUrl(key, "/offer"), body, headers());
